/* PELYKO — CRO responsive : livraison visible + avis défilants */
(function () {
  'use strict';

  var DELIVERY = '8 à 13 jours';
  var DELIVERY_FAQ = 'En France métropolitaine, comptez 2 à 3 jours ouvrés de préparation puis 6 à 10 jours d’acheminement, soit environ 8 à 13 jours au total. Le numéro de suivi La Poste vous est envoyé par e-mail dès l’expédition. Ce délai reste indicatif et peut varier selon le transporteur et la disponibilité.';

  function truckIcon() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M3.5 5.5h10.2v10H3.5zM13.7 9h3.3l3.5 3.7v2.8h-6.8z"/><circle cx="7.2" cy="17.5" r="1.9"/><circle cx="17.5" cy="17.5" r="1.9"/><path d="M5.3 17.5H3.5v-2h17v2h-1.1"/></svg>';
  }

  function deliveryCard(extraClass) {
    return '<div class="pk-delivery-card' + (extraClass ? ' ' + extraClass : '') + '">' +
      '<div class="pk-delivery-card__icon">' + truckIcon() + '</div>' +
      '<div class="pk-delivery-card__copy">' +
        '<strong>Livraison offerte · estimée ' + DELIVERY + '</strong>' +
        '<span>France métropolitaine · suivi La Poste transmis dès l’expédition</span>' +
        '<small>Délai indicatif selon le transporteur et la disponibilité.</small>' +
      '</div>' +
    '</div>';
  }

  function addStyles() {
    if (document.getElementById('pk-cro-responsive-enhancements')) return;
    var style = document.createElement('style');
    style.id = 'pk-cro-responsive-enhancements';
    style.textContent = [
      '.pk-delivery-card{display:grid;grid-template-columns:40px minmax(0,1fr);gap:12px;align-items:center;margin:14px 0 16px;padding:14px 16px;border:1px solid rgba(59,11,17,.14);border-radius:16px;background:linear-gradient(135deg,rgba(243,233,218,.78),rgba(255,255,255,.96));box-shadow:0 10px 28px rgba(30,12,10,.05);color:#1A0D0A;text-align:left}',
      '.pk-delivery-card__icon{width:40px;height:40px;display:grid;place-items:center;border-radius:12px;background:#3B0B11;color:#F3E9DA}',
      '.pk-delivery-card__icon svg{width:22px;height:22px;fill:none;stroke:currentColor;stroke-width:1.65;stroke-linecap:round;stroke-linejoin:round}',
      '.pk-delivery-card__copy{display:grid;gap:3px;min-width:0}',
      '.pk-delivery-card strong{font:700 13px/1.35 Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;letter-spacing:.005em;color:#1A0D0A}',
      '.pk-delivery-card span{font:500 11.5px/1.45 Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;color:rgba(26,13,10,.72)}',
      '.pk-delivery-card small{font:500 10.5px/1.4 Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;color:rgba(26,13,10,.52)}',
      '.pk-delivery-card--compact{margin:12px 0 14px;padding:12px 14px;grid-template-columns:36px minmax(0,1fr);border-radius:14px}',
      '.pk-delivery-card--compact .pk-delivery-card__icon{width:36px;height:36px;border-radius:10px}',
      '.pk-delivery-card--compact .pk-delivery-card__icon svg{width:20px;height:20px}',
      '#avis .pelyko-reviews-viewport{position:relative;width:100%;overflow:hidden;margin-top:clamp(20px,2.4vw,34px);-webkit-mask-image:linear-gradient(90deg,transparent 0,#000 5%,#000 95%,transparent 100%);mask-image:linear-gradient(90deg,transparent 0,#000 5%,#000 95%,transparent 100%)}',
      '#avis .pelyko-reviews-grid.pelyko-reviews-track{--pk-review-half-gap:12px;display:flex!important;grid-template-columns:none!important;align-items:stretch;gap:24px!important;width:max-content!important;max-width:none!important;margin:0!important;padding:0 0 4px!important;animation:pkReviewsLTR 44s linear infinite;will-change:transform}',
      '#avis .pelyko-reviews-track .pelyko-review-card{flex:0 0 clamp(300px,29vw,390px);width:clamp(300px,29vw,390px);max-width:none!important;min-height:100%;margin:0!important}',
      '#avis .pelyko-reviews-viewport:hover .pelyko-reviews-track,#avis .pelyko-reviews-viewport:focus-within .pelyko-reviews-track{animation-play-state:paused}',
      '@keyframes pkReviewsLTR{from{transform:translate3d(calc(-50% - var(--pk-review-half-gap)),0,0)}to{transform:translate3d(0,0,0)}}',
      '#avis .pelyko-social-strip{grid-template-columns:repeat(4,minmax(0,1fr))!important}',
      '#avis .pelyko-social-strip .pk-social-delivery span{color:#6f4a3e}',
      '@media(max-width:900px){#avis .pelyko-social-strip{grid-template-columns:repeat(2,minmax(0,1fr))!important}#avis .pelyko-reviews-track .pelyko-review-card{flex-basis:clamp(285px,68vw,360px);width:clamp(285px,68vw,360px)}}',
      '@media(max-width:720px){.pk-delivery-card{grid-template-columns:36px minmax(0,1fr);gap:10px;padding:12px 13px;margin:12px 0 14px;border-radius:14px}.pk-delivery-card__icon{width:36px;height:36px;border-radius:10px}.pk-delivery-card__icon svg{width:20px;height:20px}.pk-delivery-card strong{font-size:12.5px}.pk-delivery-card span{font-size:11px}.pk-delivery-card small{font-size:10px}#avis .pelyko-reviews-viewport{margin-top:18px;-webkit-mask-image:linear-gradient(90deg,transparent 0,#000 3%,#000 97%,transparent 100%);mask-image:linear-gradient(90deg,transparent 0,#000 3%,#000 97%,transparent 100%)}#avis .pelyko-reviews-grid.pelyko-reviews-track{--pk-review-half-gap:8px;gap:16px!important;animation-duration:36s}#avis .pelyko-reviews-track .pelyko-review-card{flex-basis:82vw;width:82vw}#avis .pelyko-social-strip{grid-template-columns:repeat(2,minmax(0,1fr))!important}}',
      '@media(prefers-reduced-motion:reduce){#avis .pelyko-reviews-viewport{overflow-x:auto;scroll-snap-type:x proximity;-webkit-mask-image:none;mask-image:none}#avis .pelyko-reviews-grid.pelyko-reviews-track{animation:none!important;transform:none!important}#avis .pelyko-reviews-track .pelyko-review-card{scroll-snap-align:start}#avis .pelyko-reviews-track .pelyko-review-card[aria-hidden="true"]{display:none!important}}'
    ].join('');
    document.head.appendChild(style);
  }

  function replaceText(root, from, to) {
    if (!root || !from) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue && node.nodeValue.indexOf(from) !== -1) {
        node.nodeValue = node.nodeValue.replace(from, to);
      }
    }
  }

  function updateDeliveryFaq(root) {
    if (!root) return;
    var details = root.querySelectorAll('details');
    Array.prototype.forEach.call(details, function (detail) {
      var summary = detail.querySelector('summary');
      if (!summary) return;
      if (summary.textContent.toLowerCase().indexOf('délai de livraison') === -1) return;
      var answer = detail.querySelector('.pelyko-faq__answer');
      if (answer) answer.textContent = DELIVERY_FAQ;
    });
  }

  function enhanceHomeDelivery() {
    var home = document.querySelector('.pelyko-home, .pelyko-shell.pelyko-home');
    if (!home) return;

    var firstBadge = document.querySelector('#garanties .pk-badge');
    if (firstBadge) {
      var strong = firstBadge.querySelector('strong');
      var span = firstBadge.querySelector('span');
      if (strong) strong.textContent = 'Livraison offerte';
      if (span) span.innerHTML = DELIVERY + '<br>France métropolitaine';
    }

    replaceText(home, 'livraison suivie et délai affiché avant validation.', 'livraison offerte et suivie, estimée à ' + DELIVERY + ' en France métropolitaine.');
    updateDeliveryFaq(home);

    var strip = document.querySelector('#avis .pelyko-social-strip');
    if (strip && !strip.querySelector('.pk-social-delivery')) {
      var item = document.createElement('div');
      item.className = 'pk-social-delivery';
      item.innerHTML = '<strong>Livraison offerte</strong><span>' + DELIVERY + '</span>';
      strip.insertBefore(item, strip.firstChild);
    }
  }

  function enhanceReviews() {
    var grid = document.querySelector('#avis .pelyko-reviews-grid');
    if (!grid || grid.getAttribute('data-pk-marquee') === '1') return;

    var originals = Array.prototype.slice.call(grid.children).filter(function (el) {
      return el.classList && el.classList.contains('pelyko-review-card');
    });
    if (originals.length < 2) return;

    grid.setAttribute('data-pk-marquee', '1');
    grid.classList.add('pelyko-reviews-track');

    originals.forEach(function (card) {
      card.removeAttribute('data-reveal');
      card.classList.add('is-visible');
    });

    originals.forEach(function (card) {
      var clone = card.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('data-reveal');
      clone.classList.add('is-visible');
      Array.prototype.forEach.call(clone.querySelectorAll('[id]'), function (el) { el.removeAttribute('id'); });
      grid.appendChild(clone);
    });

    var parent = grid.parentNode;
    var viewport = document.createElement('div');
    viewport.className = 'pelyko-reviews-viewport';
    parent.insertBefore(viewport, grid);
    viewport.appendChild(grid);
  }

  function enhanceProductDelivery() {
    var pdp = document.querySelector('.pelyko-pdp');
    if (!pdp) return;

    var priceMeta = pdp.querySelector('.pelyko-pdp-price-line span');
    if (priceMeta) priceMeta.textContent = 'TVA incluse · livraison offerte, estimée ' + DELIVERY;

    var note = pdp.querySelector('.pelyko-buybox-note');
    if (note && !pdp.querySelector('.pk-delivery-card')) {
      var holder = document.createElement('div');
      holder.innerHTML = deliveryCard('pk-delivery-card--pdp');
      note.parentNode.replaceChild(holder.firstChild, note);
    }

    var trustItems = pdp.querySelectorAll('.pelyko-pdp-trust > div');
    if (trustItems.length >= 3) {
      var trustStrong = trustItems[2].querySelector('strong');
      var trustSpan = trustItems[2].querySelector('span');
      if (trustStrong) trustStrong.textContent = 'Livraison offerte';
      if (trustSpan) trustSpan.textContent = DELIVERY;
    }

    replaceText(pdp, 'Livraison suivie en France métropolitaine.', 'Livraison offerte et suivie en France métropolitaine · estimée à ' + DELIVERY + '.');
    replaceText(pdp, 'Délai précis affiché avant la validation de la commande.', 'Délai indicatif selon le transporteur et la disponibilité.');
    updateDeliveryFaq(pdp);
  }

  function enhanceCartDelivery() {
    var cart = document.querySelector('.pelyko-cart');
    if (!cart) return;

    var head = cart.querySelector('.pelyko-checkout-head p');
    if (head) head.textContent = 'Livraison offerte et suivie en France métropolitaine · estimée à ' + DELIVERY + '. Le délai applicable est confirmé avant validation.';

    var checkoutNote = cart.querySelector('.pelyko-checkout-delivery-note');
    if (checkoutNote && !checkoutNote.classList.contains('pk-delivery-card')) {
      var holder = document.createElement('div');
      holder.innerHTML = deliveryCard('pk-delivery-card--compact');
      var replacement = holder.firstChild;
      replacement.classList.add('pelyko-checkout-delivery-note');
      checkoutNote.parentNode.replaceChild(replacement, checkoutNote);
    }
  }

  function applyEnhancements() {
    addStyles();
    enhanceHomeDelivery();
    enhanceReviews();
    enhanceProductDelivery();
    enhanceCartDelivery();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyEnhancements, { once: true });
  } else {
    applyEnhancements();
  }
  window.setTimeout(applyEnhancements, 350);
})();
